import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { trackExperimentViewed } from '@mc/track-event'
import useSticky, { type StickyConfig } from 'components/Sticky/useSticky'
import { EXPERIMENT_FLAG } from '../constants'

export const useTrackPen7570Experiment = (stickyConfig?: StickyConfig) => {
  const stickyIsActive = useSticky(stickyConfig)
  const bucket = useBucket<'control' | 'variant_1'>(EXPERIMENT_FLAG)
  const isInExperiment = !!bucket

  useEffect(() => {
    if (stickyIsActive && isInExperiment) {
      trackExperimentViewed(EXPERIMENT_FLAG)
    }
  }, [stickyIsActive, isInExperiment])
}
